import AUTH_ACTION_TYPES from '../constants/AuthConstants'

export const handleLogoutData = () => ({ type: AUTH_ACTION_TYPES.HANDLE_LOGOUT })
export const handleAuthReset = () => ({ type: AUTH_ACTION_TYPES.HANDLE_AUTH_RESET })
export const handleLoginData = (payload) => ({ type: AUTH_ACTION_TYPES.HANDLE_LOGIN, payload })
export const handleRegisterData = (payload) => ({ type: AUTH_ACTION_TYPES.HANDLE_REGISTER, payload })
export const handleUserInformation = (payload) => ({ type: AUTH_ACTION_TYPES.HANDLE_USER_INFORMATION, payload })
